import React, { useState } from 'react'
import { useForm } from 'react-hook-form'
import { Link, useHistory } from 'react-router-dom'
import { InputForm } from '../../../components/Input'
import { regExEmail } from '../../../components/RegEx'
import { Required, patternEmail, patternMinLength } from '../../../components/RegEx/ValidationMessage'
import http from '../../../config/BaseUrl'
import LoginImage from '../../../assets/images/login.jpg'
import Logo from '../../../assets/images/logo/Haylo-logo-white.png'
import classnames from 'classnames';
import '../style/style.css'

const Login = () => {
  const history = useHistory()
  const [loading, setLoading] = useState(false)
  const { register, handleSubmit, formState: { errors }, setError } = useForm({ mode: "all", reValidateMode: "all" })

  const handelLogin = async (data) => {

    try {
      setLoading(true)

      await http.post('login', data).then((res) => {

        let status = res.data.user.verify_status;
        let user_info = res.data.user;
        let userId = user_info.id;
        let userEmail = user_info.email;

        if (status === "active") {

          setTimeout(()=>{
            if (user_info.expire === 0) {
              window.location.href= '/event/type';
            } else if (user_info.expire === 1) {
              history.go('/dashboard')
            }
          }, 500)

        } else {
          let name = { email: ["email"] };
          let nameArr = [["Please verify your email"]];
          const errorNames = Object.keys(name);
          const errorMessages = Object.values(nameArr);
          errorNames.forEach((err, indx) => {
            setError(err, { type: 'required', message: errorMessages[indx][0] })
          })
          history.push('/resend/email', { id: userId, email: userEmail })
          setLoading(false)
        }
      }).catch((err) => {
        const errorNames = Object.keys(err.response.data.errors);
        const errorMessages = Object.values(err.response.data.errors);
        errorNames.forEach((err, indx) => {
          setError(err, { type: 'required', message: errorMessages[indx][0] })
        })
        setLoading(false)
      })
    } catch (error) {
      console.log(error.message);
    }

  }
  return (
    <>
      <div className="p-3 section-authentication-login p-md-0">
        <div className="px-0 container-fluid">

          <div className="row h-100">
            <div className="col-md-6 d-none d-md-block">
              <div className="page-image">
                <div className="mt-5 login-header">
                  <div className="logo">
                    <img src={Logo} className="img-fluid" alt="haylo" />
                  </div>
                </div>
                <div className="image-body">
                </div>
              </div>
            </div>
            <div className="col-md-6 col-12">
              <div className="form-body">
                <div className="row justify-content-center align-items-center h-100">
                  <div className="col-12">
                    <p className="pr-5 text-right text-secodary font-weight-bold">Don’t have an account? <Link to="/register">Sign up now</Link></p>
                  </div>
                  <div className="col-md-7 col-sm-8 col-12">
                    <div className="mx-auto my-auto h-100">
                      <div className="p-md-3">
                        <div className="text-left">
                          <h3 className="mb-4 font-weight-bold">Sign in to The Haylo</h3>
                        </div>

                        <form onSubmit={handleSubmit(handelLogin)}>
                          <div className="form-group">
                            <label htmfor="email" >Email Address<span className="text-danger pl-1 font-size-14">*</span></label>

                            <input
                              type="email"
                              name="email"
                              id="email"
                              className={`form-control mb-2 ${errors.email ? 'is-invalid' : ''}`}
                              placeholder="Enter your email address"
                              {...register("email", { required: Required, pattern: { value: regExEmail, message: patternEmail } })}
                            />

                            {/* <InputForm
                              label="Email Address"
                              type="email"
                              name="email"
                              className="form-control"
                              placeholder="Enter your email address"
                              {...register("email", { required: Required, pattern: { value: regExEmail, message: patternEmail } })}

                            /> */}
                          </div>

                          <div className="form-group">
                            <label htmfor="password" >Password<span className="text-danger pl-1 font-size-14">*</span></label>
                            <input
                              type="password"
                              name="password"
                              id="password"
                              className={`form-control mb-2 ${errors.password ? 'is-invalid' : ''}`}
                              placeholder="Enter your password"
                              {...register("password", { required: Required, minLength: { value: 6, message: patternMinLength(6) } })}
                            />
                            {/* <InputForm
                              label="Password"
                              type="password"
                              id="Password"
                              name="password"
                              className="form-control"
                              placeholder="Enter your password"
                              {...register("password", { required: Required, minLength: { value: 6, message: patternMinLength(6) } })}

                            /> */}
                          </div>
                          <div className="form-group">
                            <label class="custom-checkbox">Keep me logged in
                              <input type="checkbox" name="remember_token" />
                              <span class="custom-checkmark"></span>
                            </label>
                            <span className="error-message text-danger font-size-14">
                              {errors.check_promotion && "Please check the agreement."}
                            </span>
                          </div>
                          <div className="mt-3 btn-group w-100">
                            <button type="submit" className="btn btn-primary btn-block">
                              {loading && loading ? (<span className="spinner-border spinner-border-sm" role="status" aria-hidden="true"></span>)
                                : ("Login")
                              }
                            </button>
                          </div>
                        </form>
                      </div>
                    </div>
                  </div>
                  <div className="col-12">
                    <p className="pr-5 text-right font-weight-bold"><Link to="/forgot">Forgot Password?</Link></p>
                  </div>
                </div>

              </div>
            </div>

          </div>
        </div>

      </div>

    </>
  )
}

export default Login
